export const SCOPE_TYPES = {
  TOPIC: 'topic',
} as const;

export type ScopeType = (typeof SCOPE_TYPES)[keyof typeof SCOPE_TYPES];

export interface ScopeObject {
  id: string;
}
